import { Button, Stack } from "@mui/material";
import { useRecordContext } from "react-admin";
import { useAuth } from "../../../hooks/useAuth";

// #57 - white glove: a principal starts a request flow ON BEHALF of this
// agent. Rendered on the Agents list, the agent detail page, and My Downline;
// invisible to everyone but agency principals. The flow itself re-authorizes
// the agent server-side.
const StartRequestButtons = ({ record: recordProp, size = "small" }) => {
  const ctxRecord = useRecordContext();
  const record = recordProp || ctxRecord;
  const { user, isAgencyAdmin } = useAuth();
  if (!record || !isAgencyAdmin(user)) return null;
  const go = (path) => (e) => {
    e.stopPropagation();
    window.location.href = `${path}?agent=${record.id}`;
  };
  return (
    <Stack direction="row" spacing={1}>
      <Button size={size} variant="outlined" onClick={go("/contract")}>
        Start contract request
      </Button>
      <Button size={size} variant="outlined" onClick={go("/add-state")}>
        Start add state
      </Button>
    </Stack>
  );
};

export default StartRequestButtons;
